import { GetThemePacks } from '@/connection/theme-packs';
import { ContentReducerCreator } from '../types';

const loadThemePacksReducer = (create: ContentReducerCreator) => {
  return create.asyncThunk(
    async (channel: number) => {
      return await GetThemePacks(channel);
    },
    {
      rejected: (state, action) => {
        console.error(action.error.stack);
      },
      pending: (state) => {
        state.loadingContent = true;
      },
      fulfilled: (state, action) => {
        state.themePacks = action.payload;
      },
      settled: (state) => {
        state.loadingContent = false;
      },
    }
  );
};

export default loadThemePacksReducer;
